export default __webpack_public_path__ + "static/media/contact-bg.54efc2a1.png";